import Vue from 'vue';
import Component from 'vue-class-component';
import { CORE_ROUTES } from '@/core/core.router';
import { PHONE_VERIFY_STATUS } from '@/auth/values/auth.values';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';

@Component({
  name: 'user-verify',
  components: {
  },
})
export default class UserVerifyView extends Vue {

  /* Data */
  public validating: boolean = false;
  public code: number = null;
  public userVerified: boolean = false;

  /* Computed */
  get codeInvalid () { 
    return !this.code || this.code?.toString().length < 6;
  }

  /* Methods */
  public async validate() {
    this.validating = true;
    try {
      let response = await this.$Auth.Services.validateEmailCode(this.code, this.$route.params.verificationId);
      if (response.status == PHONE_VERIFY_STATUS.VALIDATED) {
        this.userVerified = true;
      } else {
        this.$EdToast.create({ 
          msg: `${this.$t('auth.register.errors.userNoVerified')}`,
          type: TOAST_TYPES.DANGER,
          top: '5.5rem',
          timeout: 3000
        });
      }
      this.validating = false;
    } catch {
      this.$EdToast.create({ 
        msg: `${this.$t('auth.register.errors.userNoVerified')}`,
        type: TOAST_TYPES.DANGER,
        top: '5.5rem',
        timeout: 3000
      });
      this.validating = false;
    }
  }

  public goHome() {
    this.$router.push({ name: CORE_ROUTES.HOME.NAME })
  }

  public goLogin() {
    this.$router.push({ name: CORE_ROUTES.HOME.NAME })
  }

  getCode(code) {
    this.code = Number(code)
  }

  beforeMount () {
    const $root: any = this.$root;
    $root.logout(false)
  }
}